// extracted by mini-css-extract-plugin
export default {"premium-folder-icon":"Gs00-","premiumFolderIcon":"Gs00-","widget-paywall-locked":"G6jxz","widgetPaywallLocked":"G6jxz"};